// extracted by mini-css-extract-plugin
export default {"space":"scan-request_space__wb8Ys"};